export default __webpack_public_path__ + "static/media/Nav_profile.64d80d71.svg";